import api from '../lib/utils/apiConfig';

const masterService = {
  getMasters: async (type) => {
    const response = await api.get(`/masters/${type}`);
    return response.data;
  },

  getReferenceMasters: async (type) => {
    const response = await api.get(`/public/masters/${type}`);
    return response.data?.data || [];
  },

  createMaster: async (type, data) => {
    const response = await api.post(`/masters/${type}`, data);
    return response.data;
  },

  updateMaster: async (type, id, data) => {
    const response = await api.put(`/masters/${type}/${id}`, data);
    return response.data;
  },

  deleteMaster: async (type, id) => {
    const response = await api.delete(`/masters/${type}/${id}`);
    return response.data;
  },

  updateOrder: async (type, orders) => {
    const response = await api.patch(`/masters/${type}/reorder`, { orders });
    return response.data;
  }
};

export default masterService;
